import { render, staticRenderFns } from "./ProductAccessories.vue?vue&type=template&id=a8b7cd00&"
import script from "./ProductAccessories.vue?vue&type=script&lang=js&"
export * from "./ProductAccessories.vue?vue&type=script&lang=js&"
import style0 from "./ProductAccessories.vue?vue&type=style&index=0&id=a8b7cd00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports